import React from 'react';
import { useState, useEffect } from 'react';
import './styles/home.css';
import Axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'
import './styles/express.css';

const Home = (props) => {
    const [homeContent, setHomeContent] = useState(props.homeContent);
    const [userID, setUserID] = useState(props.userID);
    const [tempdisable, setTempDisable] = useState(false);
    const [showReplyBox, setShowReplyBox] = useState('');
    const [replyContent, setReplyContent] = useState('');
    const [showMore, setShowMore] = useState('');
    const [reporteText, setReportText] = useState('Report')

    useEffect(() => {
        setHomeContent(props.homeContent);
        // setUserID(props.userID);
    }, [props.homeContent]);
    useEffect(() => {
        setUserID(props.userID);
    }, [props.userID]);

    // useEffect(() => {
    //     let temp = props.homeContent;
    //     for (let i = 0; i < temp.length; i++) {
    //         temp[i]['liked'] = false;
    //         for (let j = 0; j < temp[i].userWhoLiked.length; j++) {
    //             temp[i]['liked'] = true;
    //         }
    //     }

    // }, []);
    const doLike = (_id) => {
        if (userID) {
            document.getElementById('likeSound').play()
            setTempDisable(true);
            props.likeHandler(_id)
            Axios.post('https://conffesion.herokuapp.com/dolike', { userID: userID, postID: _id })
                .then(res => {
                    // let temp = homeContent;
                    // for (let i = 0; i < temp.length; i++) {
                    //     if (temp[i]._id === _id) {
                    //         temp[i]['liked'] = true;
                    //     }
                    // }
                    // setHomeContent(temp)

                    setTempDisable(false);
                })
                .catch(err => { setTempDisable(false) });
        } else {
            // toast("Please log in (or Refresh if already done)");
        }
    }
    const doReply = (_id) => {
        if (replyContent.length != 0) {
            Axios.post('https://conffesion.herokuapp.com/reply', { postID: _id, content: replyContent })
                .then(res => {
                    let temp = homeContent;
                    for (let i = 0; i < homeContent.length; i++) {
                        if (String(_id) == String(homeContent[i].userID)) {
                            temp[i].comments.push({ name: '', content: replyContent });
                        }
                    }
                    setHomeContent(temp);
                    setShowReplyBox('');
                    setReplyContent('');

                })
                .catch(err => {
                    setShowReplyBox('');
                    setReplyContent('');
                });

        }
    }
    const doReport = (thePost) => {
        try {
            let f = thePost.reportes.find((f) => f == userID);
            if (typeof f != 'undefined' || userID == null) {
                //Alreasy reported
                // setReportText('Reported')

            } else {
                Axios.post('https://conffesion.herokuapp.com/report', { reporterID: userID, postID: thePost._id })
                    .then(res => {
                        setShowMore('');
                        let temp = homeContent;
                        for (let i = 0; i < homeContent.length; i++) {
                            if (String(thePost._id) == String(homeContent[i]._id)) {
                                temp[i].reportes.push(userID);
                            }
                        }
                        setHomeContent(temp);
                    })
                    .catch(err => { });
            }
        } catch{
        }
    }
    const morehandler = (thePost) => {
        // console.log(thePost)
        try {
            let f = thePost.reportes.find((f) => f == userID);
            if (typeof f !== 'undefined') {
                //Alreasy reported
                setReportText('Reported');

            } else {
                setReportText('Report');
            }
        } catch{
        }
    }


    return (
        <div>


            {/* <ToastContainer /> */}
            {homeContent.map(eachPost => {

                return (
                    <div className='card cardEach animated bounceInDown ' id="" key={eachPost._id}>
                        <div className=""><strong className='heading' style={{ fontSize: '1.2rem', marginTop: '0.2rem' }}>{" To, " + eachPost.name}</strong>{eachPost._id === userID ? (' (you)') : ('')}<div className='more' onClick={() => { setShowMore(showMore.length == 0 ? eachPost._id : ''); morehandler(eachPost) }}>....</div>
                            {showMore == eachPost._id ? (
                                <div className='reportBox'>
                                    <button className='btn btn-outline secondary' onClick={() => { doReport(eachPost) }}>({reporteText})</button>
                                </div>
                            ) : (
                                    <p></p>
                                )}
                        </div>
                        <div className="card-body ">
                            <blockquote>
                                <p className='heading'>{eachPost.content}</p>
                                {/* <cite>Abraham Lincoln</cite> */}
                            </blockquote>

                        </div>
                        <div className=" cf">

                            {eachPost.userWhoLiked.length}
                            {eachPost.liked ? (
                                <button className='btn btn-default' > <span className='heartActive animated bounceIn'></span></button>

                            ) : (
                                    <button className='btn btn-default' disabled={tempdisable} onClick={() => { doLike(eachPost._id) }}>  <span className='heart'></span></button>
                                )}
                            {String(eachPost.userID) == String(userID) && eachPost.comments.length === 0 ? (
                                <div className='replyDiv'><span className="replyIcon" onClick={() => { setShowReplyBox(eachPost._id) }}></span> </div>
                            ) : (
                                    <div>
                                    </div>
                                )}
                            {showReplyBox === eachPost._id && eachPost.comments.length === 0 ? (
                                <div>
                                    <div className="form__group field">
                                        <input type="input" className="form__field" placeholder="Reply" name="reply" id='name' value={replyContent} onChange={(e) => { setReplyContent(e.target.value) }} />
                                        <label className="form__label">Reply</label>
                                        <button className='btn btn-default' style={{ position: 'relative', float: 'right' }} onClick={() => { doReply(eachPost._id) }}>Post</button>
                                        <button className="btn btn-default" onClick={() => { setShowReplyBox('') }}>Nope</button>
                                    </div>

                                </div>
                            ) : (
                                    <p></p>
                                )}
                            {
                                eachPost.comments.length === 0 ? (
                                    <p></p>
                                ) : (
                                        <div className='replyBox'>
                                            <strong style={{ fontSize: "xx-small" }}>~ Replied by {eachPost.name}</strong>
                                            <p style={{ fontSize: 'small' }}>{eachPost.comments[0].content}</p>
                                        </div>
                                    )
                            }
                        </div>
                    </div>)
            })}
            {
                homeContent.length === 0 ? (<div className='contain'>
                    <svg height='80' viewBox='-30 0 255 80' width='255'>
                        <ellipse cx='25' cy='20' fill='none' rx='10' ry='10'></ellipse>
                    </svg>
                    <svg height='80' viewBox='-30 0 255 80' width='255'>
                        <ellipse cx='25' cy='20' fill='none' rx='10' ry='10'></ellipse>
                    </svg>
                    <svg height='80' viewBox='-30 0 255 80' width='255'>
                        <ellipse cx='25' cy='20' fill='none' rx='10' ry='10'></ellipse>
                    </svg>
                    <svg height='80' viewBox='-30 0 255 80' width='255'>
                        <ellipse cx='25' cy='20' fill='none' rx='10' ry='10'></ellipse>
                    </svg>
                    <svg height='80' viewBox='-30 0 255 80' width='255'>
                        <ellipse cx='25' cy='20' fill='none' rx='10' ry='10'></ellipse>
                    </svg>
                    <svg height='80' viewBox='-30 0 255 80' width='255'>
                        <ellipse cx='25' cy='20' fill='none' rx='10' ry='10'></ellipse>
                    </svg>
                    <svg height='80' viewBox='-30 0 255 80' width='255'>
                        <ellipse cx='25' cy='20' fill='none' rx='10' ry='10'></ellipse>
                    </svg>
                    <svg height='80' viewBox='-30 0 255 80' width='255'>
                        <ellipse cx='25' cy='20' fill='none' rx='10' ry='10'></ellipse>
                    </svg>
                    <svg height='80' viewBox='-30 0 255 80' width='255'>
                        <ellipse cx='25' cy='20' fill='none' rx='10' ry='10'></ellipse>
                    </svg>
                    <svg height='80' viewBox='-30 0 255 80' width='255'>
                        <ellipse cx='25' cy='20' fill='none' rx='10' ry='10'></ellipse>
                    </svg>
                </div>) : ('')
            }
            <audio controls hidden id="likeSound">
                {/* <source src="horse.ogg" type="audio/ogg" /> */}
                <source src="https://res.cloudinary.com/rupamcloud/video/upload/v1579687269/multimedia_button_click_004_zwvgcq.mp3" type="audio/mpeg" />
            </audio>

        </div>

    )
}
export default Home;